import { EndpointConfig } from '@services/api/declarations'

export const patchUserChangePasswordConfig: EndpointConfig = {
  storeKey: 'patchUserChangePassword',
  url: '/api/users/change-password',
}

export const getUserProfileConfig: EndpointConfig = {
  storeKey: 'getUserProfile',
  url: '/api/profile',
}

export const postUserPasswordResetConfirmConfig: EndpointConfig = {
  storeKey: 'postUserPasswordResetConfirm',
  url: '/api/users/password-reset/confirm',
}

export const postUserPasswordResetRequestConfig: EndpointConfig = {
  storeKey: 'postUserPasswordResetRequest',
  url: '/api/users/password-reset/request',
}

export const postUserPasswordResetValidateConfig: EndpointConfig = {
  storeKey: 'postUserPasswordResetValidate',
  url: '/api/users/password-reset/validate',
}

export const getUserByUsernameConfig: EndpointConfig = {
  storeKey: 'getUserByUsername',
  url: '/api/users/:username',
}

export const postUserRegisterConfig: EndpointConfig = {
  storeKey: 'postUserRegister',
  url: '/api/users/register',
}

export const postCreateProfileConfig: EndpointConfig = {
  storeKey: 'postCreateProfile',
  url: '/api/profiles/:profileType',
}

export const getOrphanedManagersConfig: EndpointConfig = {
  storeKey: 'getOrphanedManagers',
  url: '/api/users/orphaned-managers',
}

export const postConfirmEmailConfig: EndpointConfig = {
  storeKey: 'postConfirmEmail',
  url: '/api/users/confirm-email',
}

export const postValidateEmailConfig: EndpointConfig = {
  storeKey: 'postValidateEmail',
  url: '/api/users/validate-email',
}